import { RootState } from "redux/rootReducer";

export const selectSession = (state: RootState) => state.auth.session;
export const selectIsLoggedIn = (state: RootState) => state.auth.session !== null;
export const selectAuthInitialized = (state: RootState) => state.auth.initialized;
export const selectLoginError = (state: RootState) => state.auth.loginError;
export const selectIsLoggingIn = (state: RootState) =>
  Boolean(state.requesting["auth/login"]);

export const selectLoginModalOpen = (state: RootState) => state.auth.loginModalOpen;
export const selectAuthNotice = (state: RootState) => state.auth.notice;
